import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import { getOptionsFromEnum } from "../../../toolkit/utils/enum-utils";
import { InvitadoEstatus, InvitadoTipo } from "../../../types/Invitado";
import IEmpresaConvenioSelectorBuilder from "../../../toolkit/baseForms2Commons/iEmpresaConvenioSelectorBuilder/IEmpresaConvenioBuilder";

export type Inputs = "idPersona" | "nombre" | "tipo" | "estatus" | "idEmpresa";
export type Buttons = "activar" | "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idPersona",
      label: "Id de Persona",
      bts: {
        mCol: 2
      },
      component: ITextBuilder,
      props: {
        type: "NUMERIC"
      }
    },
    {
      name: "nombre",
      label: "Nombre del invitado",
      bts: {
        mCol: 3
      },
      component: ITextBuilder,
      props: {
        disabled: values => !!values.idPersona
      }
    },
    {
      name: "tipo",
      label: "Tipo",
      bts: {
        mCol: 2
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Todos",
        data: getOptionsFromEnum(InvitadoTipo),
        disabled: values => !!values.idPersona
      }
    },
    {
      name: "estatus",
      label: "Estatus",
      bts: {
        mCol: 2
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Todos",
        data: getOptionsFromEnum(InvitadoEstatus),
        disabled: values => !!values.idPersona
      }
    },
    {
      name: "idEmpresa",
      label: "Empresa",
      bts: {
        mCol: 3
      },
      component: IEmpresaConvenioSelectorBuilder,
      props: {
        todas: true,
        disabled: values => !!values.idPersona,
        ignorarConvenio: true
      }
    }
  ],
  buttons: [
    {
      name: "activar",
      label: "Activar seleccionados",
      bts: {
        mOff: 6,
        mCol: 3
      },
      component: IButtonBuilder
    },
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  rows: [
    ["idPersona", "nombre", "tipo", "estatus", "idEmpresa"],
    ["activar", "buscar"]
  ]
};
